<template>
  <button class="button-block" @click="$emit('click', $event)">
    <div class="button" :style="themeButton">
      <slot>{{ label }}</slot>
    </div>
    <div class="button-backing" :style="themeButtonBack"></div>
  </button>
</template>

<script>
export default {
  name: 'button-block',
  props: {
    label: String,
    // style
    bg: String,
    fg: String,
  },
  computed: {
    themeButton () {
        return {
            background: this.bg,
            color: this.fg,
            borderColor: this.fg,
            boxShadow: `2px 2px 0 ${this.bg}`,
        };
    },
    themeButtonBack () {
      let bg = 'transparent'; //this.bg;
      let fg = this.fg;
      return {
        backgroundImage: `linear-gradient(
          45deg, 
          ${bg} 25%, 
          ${fg} 25%, 
          ${fg} 50%, 
          ${bg} 50%, 
          ${bg} 75%, 
          ${fg} 75%, 
          ${fg} 100%)`,
        backgroundSize: '19.80px 19.80px',//'25.46px 25.46px',//"56.57px 56.57px",
      }
    }
  },
}
</script>

<style lang="scss">
.button-block{
  position: relative;

  // button reset
  padding: 0;
  margin: 0;
  border: none;
  display: block;
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 100%;
  padding-right: 10px;
  padding-bottom: 10px;
  background-color: transparent;
  overflow: hidden;

  .button {
    font-family: 'regina_blacksolid', serif;
    display: block;
    height: 100%;
    font-size: 3em;

    padding: 0;
    margin: 0;
    background: black;
    color: white;

    padding: 10px 15px;
    border: 3px solid white;
    position: relative;
    z-index: 2;

    box-shadow: 2px 2px 0 black;
  }

  // &:before {
  //  content: '';
  .button-backing {
    position: absolute;
    // background-color: white; // mask to angle strokes
    display: block;
    height: 100%;
    padding-right: 5px;
    left: 5px;
    bottom: 0;
    right: 0;
    top: 10px;
    z-index: 1;

    background-image: linear-gradient(45deg, 
      black 25%, 
      transparent 25%, 
      transparent 50%, 
      black 50%, 
      black 75%, 
      transparent 75%, 
      transparent 100%);
    background-size: 19.80px 19.80px;
  }

  .button {
    transition: transform 0.2s;
  }
  &:hover .button {
    transform: translate(2px, 2px);
  }
  .button-backing {
    transition: background-position 0.2s, background-size 0.2s, left 0.2s;
  }
  &:hover .button-backing {
    background-position: -10px 0;
    background-size: 15.8px 15.8px !important;
    left: 10px;
  }

}
</style>
